import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { ENTITY_TYPE } from "layout/documentUploader/constants";
import { oneOf } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

export const LOCATION_TYPE_LABELS = {
  [ENTITY_TYPE.PROPOSAL]: "Proposal",
  [ENTITY_TYPE.OPPORTUNITY]: "Tracked Opp",
  [ENTITY_TYPE.CONTRACT]: "Contract",
  [ENTITY_TYPE.MISC_ANALYSIS]: "Misc",
};

const AddInNameClashPrompt = ({ entityType }) => {
  const dispatch = useDispatch();
  const entityLabel = LOCATION_TYPE_LABELS[entityType];

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.ADD_IN_NAME_CLASH_PROMPT));
  };

  return (
    <Modal
      data-testid="add-in-name-clash-prompt"
      show
      onDismiss={onDismiss}
      backdrop
      centered
    >
      <Modal.Header>Doc Already Exists</Modal.Header>

      <Modal.Body>
        <p>
          A doc with this name already exists in the {entityLabel}. You need to
          first save this doc in MS Word with a different name
        </p>
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l1}
          onClick={onDismiss}
        >
          Ok
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

AddInNameClashPrompt.propTypes = {
  entityType: oneOf(Object.values(ENTITY_TYPE)),
};

export default AddInNameClashPrompt;
